import React from 'react';
import { Box, styled } from '@mui/material';
import { PageHeader } from 'components/PageHeader/PageHeader';
import {
  getHealthTopicBackgroundColor,
  getHealthTopicIcon,
} from 'features/resources/utils/healthTopicUtils';
import type { HealthTopic } from 'features/resources/types';

interface CareProgramsListHeaderProps {
  healthTopic: HealthTopic;
}

const IconBanner = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1.5, 4),
  '& svg, & img': {
    width: 100,
    height: 100,
  },
}));

export const CareProgramsIconBanner: React.FC<CareProgramsListHeaderProps> = ({ healthTopic }) => {
  const TopicIcon = getHealthTopicIcon(healthTopic);
  const bannerColor = getHealthTopicBackgroundColor(healthTopic);

  return (
    <>
      <IconBanner
        className="care-programs-list-page__banner"
        sx={{ backgroundColor: bannerColor }}
        aria-hidden="true"
      >
        <TopicIcon />
      </IconBanner>
    </>
  );
};
